<template>
  <div>
    <DxForm :form-data="localData" label-position="top" :ref="formRef">
      <DxGroupItem :col-count="7" css-class="second-group">
        <DxSimpleItem
          data-field="idProduct"
          editor-type="dxSelectBox"
          :validation-rules="validationRules.idProduct"
          :editor-options="idProductOptions"
        >
          <DxLabel :text="$t('OrderLine.IdProduct')" />
        </DxSimpleItem>
        <DxSimpleItem
          :col-span="3"
          data-field="description"
          label-mode="floating"
          :validation-rules="validationRules.description"
        >
          <DxLabel :text="$t('OrderLine.Description')" />
        </DxSimpleItem>
        <DxSimpleItem
          data-field="quantity"
          editor-type="dxNumberBox"
          :editor-options="{ inputAttr: { style: 'text-align: right' } }"
           :validation-rules="validationRules.quantity"
        >
          <DxLabel :text="$t('OrderLine.Quantity')" alignment="right" />
        </DxSimpleItem>
        <DxSimpleItem
          data-field="pricePerUnit"
          editor-type="dxNumberBox"
          :editor-options="{
            format: { type: 'currency', precision: 2 },
            inputAttr: { style: 'text-align: right' },
          }"
           :validation-rules="validationRules.pricePerUnit"
          ><DxLabel :text="$t('OrderLine.PricePerUnit')" alignment="right"
        /></DxSimpleItem>
        <DxItem name="amountTotal">
          <template #default>
            <div class="total">
              {{ (localData.quantity * localData.pricePerUnit) | currency }}
            </div>
          </template>
          <DxLabel :text="$t('OrderLine.Total')" alignment="right" />
        </DxItem>
        <DxEmptyItem :col-span="4" />
        <DxSimpleItem
          v-if="localData.idProduct == 1"
          data-field="startDate"
          editor-type="dxDateBox"
          ><DxLabel :text="$t('OrderLine.StartDate')"
        /></DxSimpleItem>
        <DxSimpleItem
          v-if="localData.idProduct == 1"
          data-field="endDate"
          editor-type="dxDateBox"
          ><DxLabel :text="$t('OrderLine.EndDate')"
        /></DxSimpleItem>
      </DxGroupItem>
    </DxForm>
  </div>
</template>

<script>

import { notifyMixin } from '@/mixins/notifyMixin'
import {
  DxForm,
  DxItem,
  DxSimpleItem,
  DxEmptyItem,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';
import { DxNumberBox } from 'devextreme-vue/number-box'

export default {
  mixins: [notifyMixin],
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxEmptyItem,
    DxNumberBox,
    DxItem,
    DxLabel
  },
  props: {
    templateData: {
      type: Object,
      default: () => { }
    },
    showLabels: Boolean
  },
  data () {
    const products = this.$store.state.refCodes.products.map(a => {
      return { ...a, description: this.$t(`Products.${a.description}`) }
    })
    return {
      localData: { ...this.templateData },
      idProductOptions: {
        items: products,
        displayExpr: "description",
        valueExpr: "id"
      },
      validationRules: {
        idProduct: [
          { type: 'required', message: this.$t('OrderLine.IdProductRequired') },
        ],
        description: [
          { type: 'required', message: this.$t('OrderLine.DescriptionRequired') },
        ],
        quantity: [
          { type: 'required', message: this.$t('OrderLine.QuantityRequired') },
          { type: 'range', min: 1, max: 1000,  message: this.$t('OrderLine.QuantityRange') },
        ],
        pricePerUnit: [
          { type: 'required', message: this.$t('OrderLine.PricePerUnitRequired') },
          { type: 'range', min: -100000, max: 100000,  message: this.$t('OrderLine.PricePerUnitRange') },
        ],
      },
    }
  },
  watch: {
    localData: {
      deep: true,
      handler (val) {
        const form = this.$refs[this.formRef].instance
        const result = form.validate()
        val.isValid = result.isValid
        this.$emit("values-changed", val)
      }
    }
  },
  methods: {

  },
  created () {

  },
  computed: {
    amountTotal () {
      const ret = this.localData.quantity * this.localData.pricePerUnit
      console.log("AmountTotal computed", ret)
      return ret
    },
    formRef () {
      return `order-line-form-${this.localData.id}`
    }
  }
}
</script>

<style scoped>
.total {
  font-size: larger;
  margin-top: 18px;
  font-weight: bolder;
  text-align: right;
}
</style>